import * as React from 'react';

import Breadcrumbs from 'af-components/Breadcrumbs';

import { BREADCRUMBS } from './constants';
import NotificationSettingsForms from './NotificationSettingsForms';
import styles from './styles.module.scss';

const RegistrationAndDeactivationNotificationSettings: React.FC = () => {

	return (
		<div className={styles['notification-settings']}>
			<Breadcrumbs items={BREADCRUMBS} />
			<NotificationSettingsForms />
		</div>
	);
};

export default React.memo(RegistrationAndDeactivationNotificationSettings);
